import { Modal, Grid, Drawer } from "antd";
import useCoarsePointer from "@/lib/hooks/useCoarsePointer";

const { useBreakpoint } = Grid;

interface FullScreenModalProps {
  title?: string | React.ReactNode;
  ariaLabel?: string;
  /** Reserve a stable desktop profile viewport while details load. */
  stableHeight?: boolean;
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
}
const FullScreenModal = ({
  title,
  ariaLabel,
  stableHeight = false,
  open,
  children,
  onClose,
}: FullScreenModalProps) => {
  const screens = useBreakpoint();
  const coarsePointer = useCoarsePointer();
  // Touch devices get the fullscreen drawer even at desktop widths; see the
  // hook for why width alone is not enough.
  if (screens.md && !coarsePointer) {
    return (
      <Modal
        aria-label={ariaLabel}
        width={"700px"}
        title={title}
        open={open}
        onCancel={onClose}
        centered
        footer={null}
        closeIcon={null}
        styles={{
          container: {
            padding: 0,
            overflow: "hidden",
          },
          header: {
            padding: "12px",
            borderBottom: "none",
            zIndex: 9,
          },
          wrapper: {
            height: "100%",
          },
          body: {
            padding: 0,
            display: "flex",
            flexDirection: "column",
            maxHeight: "calc(100dvh - 48px)",
            ...(stableHeight ? { height: "min(820px, calc(100dvh - 48px))" } : {}),
            overflow: "hidden",
          },
        }}
      >
        {children}
      </Modal>
    );
  }

  return (
    <Drawer
      aria-label={ariaLabel}
      title={title}
      closeIcon={null}
      styles={{
        header: {
          padding: "10px",
          borderBottom: "none",
          zIndex: 9,
        },
        wrapper: {
          height: "100%",
        },
        mask: {
          background: "transparent",
        },
        body: {
          padding: 0,
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        },
      }}
      autoFocus
      placement="bottom"
      destroyOnHidden
      open={open}
      onClose={onClose}
    >
      {children}
    </Drawer>
  );
};

export default FullScreenModal;
